import script from "./AdminErrorView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminErrorView.vue?vue&type=script&setup=true&lang=js"

import "./AdminErrorView.vue?vue&type=style&index=0&id=c0cc5276&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0cc5276"]])

export default __exports__